const compressionOptions = {
  maxSizeMB: 1,
  maxWidthOrHeight: 1920,
  useWebWorker: true,
  libURL: '/browser-image-compression.js',
};

const SKIP_COMPRESSION_TYPES = new Set(['image/svg+xml', 'image/gif', 'image/webp']);

export const compressImage = async (file: File, signal?: AbortSignal): Promise<File> => {
  // skip compression for small files or non-compressible formats
  if (file.size < 100 * 1024 || SKIP_COMPRESSION_TYPES.has(file.type)) {
    return file;
  }

  const { default: imageCompression } = await import('browser-image-compression');

  return imageCompression(file, { ...compressionOptions, signal });
};
